import { type RouteRecordRaw } from 'vue-router'

import { useProgEventStore } from '../progEvent/progEvent.store'
import { useApplicationCfgStore } from './applicationCfg.store'

export const ApplicationCfgRouter: RouteRecordRaw[] = [
  {
    path: '/applicationCfg',
    component: async () => import('./applicationCfg.vue'),
    async beforeEnter() {
      await Promise.all([
        useApplicationCfgStore.getState().loadApplicationCfg(),
        useProgEventStore.getState().list(),
      ])
    },
  },
]
